import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { Button } from "@ankaadia/ankaadia-shared-frontend";
import { TranslateDirective } from "../../shared/transloco/translate.directive";
import { NewUiErrorComponent } from "./new-ui-error.component";

@Component({
  selector: "app-error",
  templateUrl: "./error.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, RouterLink, Button],
})
export class ErrorComponent extends NewUiErrorComponent {}
